"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertSagas = void 0;
var effects_1 = require("redux-saga/effects");
var AlertAction_1 = require("@/pages/alert/actions/AlertAction");
var SaveSearchApiSaga_1 = require("@/pages/search/sagas/api/SaveSearchApiSaga");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var NotificationChannelTypes_1 = require("@/pages/alert/states/NotificationChannelTypes");
var getMarketUpdate = function (state) { return state.alert.marketUpdate; };
var getCurrentSaveSearches = function (state) { return state.alert.savedSearches; };
var getCurrentFollows = function (state) { return state.alert.followingPlaces; };
var getSaveSearchNotificationChannel = function (state, id) { return state.alert.savedSearches
    .find(function (it) { return it.notificationId === id; })
    .notificationChannels; };
var getFollowingNotificationChannel = function (state, id) { return state.alert.followingPlaces
    .find(function (it) { return it.notificationId === id; })
    .notificationChannels; };
var getIsAllSaveSearchEmailEnabled = function (state) { return state.alert.savedSearches
    .map(function (it) { return it.notificationChannels; })
    .findIndex(function (it) { return it.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.Email) === -1; }) > -1 ? false : true; };
var getIsAllSaveSearchMobileEnabled = function (state) { return state.alert.savedSearches
    .map(function (it) { return it.notificationChannels; })
    .findIndex(function (it) { return it.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.AppPush) === -1; }) > -1 ? false : true; };
var getIsAllFollowingEmailEnabled = function (state) { return state.alert.followingPlaces
    .map(function (it) { return it.notificationChannels; })
    .findIndex(function (it) { return it.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.Email) === -1; }) > -1 ? false : true; };
var getIsAllFollowingMobileEnabled = function (state) { return state.alert.followingPlaces
    .map(function (it) { return it.notificationChannels; })
    .findIndex(function (it) { return it.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.AppPush) === -1; }) > -1 ? false : true; };
var getSaveSearchEmailNotificationIds = function (state) { return state.alert.savedSearches
    .filter(function (it) { return it.notificationChannels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.Email) > -1; })
    .map(function (it) { return it.notificationId; }); };
var getSaveSearchEmailNotificationIdsUnchecked = function (state) { return state.alert.savedSearches
    .filter(function (it) { return it.notificationChannels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.Email) === -1; })
    .map(function (it) { return it.notificationId; }); };
var getSaveSearchMobileNotificationIds = function (state) { return state.alert.savedSearches
    .filter(function (it) { return it.notificationChannels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.AppPush) > -1; })
    .map(function (it) { return it.notificationId; }); };
var getSaveSearchMobileNotificationIdsUnchecked = function (state) { return state.alert.savedSearches
    .filter(function (it) { return it.notificationChannels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.AppPush) === -1; })
    .map(function (it) { return it.notificationId; }); };
var getFollowingPlacesEmailNotificationIds = function (state) { return state.alert.followingPlaces
    .filter(function (it) { return it.notificationChannels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.Email) > -1; })
    .map(function (it) { return it.notificationId; }); };
var getFollowingPlacesEmailNotificationIdsUnchecked = function (state) { return state.alert.followingPlaces
    .filter(function (it) { return it.notificationChannels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.Email) === -1; })
    .map(function (it) { return it.notificationId; }); };
var getFollowingPlacesMobileNotificationIds = function (state) { return state.alert.followingPlaces
    .filter(function (it) { return it.notificationChannels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.AppPush) > -1; })
    .map(function (it) { return it.notificationId; }); };
var getFollowingPlacesMobileNotificationIdsUnchecked = function (state) { return state.alert.followingPlaces
    .filter(function (it) { return it.notificationChannels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.AppPush) === -1; })
    .map(function (it) { return it.notificationId; }); };
var watchOnChangeSaveSearchAlert = function () {
    var payload, id, frequency;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(AlertAction_1.default.ON_CHANGE_SAVE_SEARCH_ALERT)];
            case 1:
                payload = (_a.sent()).payload;
                id = payload.id;
                frequency = payload.frequency;
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.setSaveSearchAlertEnabled(id, frequency))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnChangeMarketUpdate = function () {
    var enabled;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(AlertAction_1.default.ON_CHANGE_MARKET_UPDATE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getMarketUpdate)];
            case 2:
                enabled = _a.sent();
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.setMarketUpdate(!enabled))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchAlertSave = function () {
    var marketEnabled, currentSaveSearches, currentFollows, searchSets, response2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 14];
                return [4 /*yield*/, effects_1.take(AlertAction_1.default.ON_ALERT_SAVE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getMarketUpdate)];
            case 2:
                marketEnabled = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSaveSearches)];
            case 3:
                currentSaveSearches = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentFollows)];
            case 4:
                currentFollows = _a.sent();
                searchSets = currentSaveSearches.concat(currentFollows);
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.setIsLoading(true))];
            case 5:
                _a.sent();
                if (!(searchSets && searchSets.length)) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.call(SaveSearchApiSaga_1.saveSearchSetsApi, searchSets)];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [4 /*yield*/, effects_1.call(SaveSearchApiSaga_1.setUserSubscribeApi, marketEnabled)];
            case 8:
                response2 = _a.sent();
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.setIsLoading(false))];
            case 9:
                _a.sent();
                if (!(response2 && response2.data.result.status === 2)) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('alertUpdateSuccess'))];
            case 10:
                _a.sent();
                return [3 /*break*/, 13];
            case 11: return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('alertUpdateFailed'))];
            case 12:
                _a.sent();
                _a.label = 13;
            case 13: return [3 /*break*/, 0];
            case 14: return [2 /*return*/];
        }
    });
};
var watchSaveSearchEmailEnabled = function () {
    var _loop_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_1 = function () {
                    var payload, notificationId, channels, emailIndex, newChannel;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(AlertAction_1.default.ON_CHANGE_SAVE_SEARCH_EMAIL_ENABLED)];
                            case 1:
                                payload = (_a.sent()).payload;
                                notificationId = payload;
                                return [4 /*yield*/, effects_1.select(getSaveSearchNotificationChannel, notificationId)];
                            case 2:
                                channels = _a.sent();
                                emailIndex = channels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.Email);
                                newChannel = emailIndex > -1
                                    ? __spreadArrays(channels.slice(0, emailIndex), channels.slice(emailIndex + 1)) : __spreadArrays(channels, [NotificationChannelTypes_1.NotificationChannelTypes.Email]).sort();
                                return [4 /*yield*/, effects_1.fork(function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, effects_1.put(AlertAction_1.default.setSaveSearchSetChannel(notificationId, newChannel))];
                                                case 1:
                                                    _a.sent();
                                                    return [4 /*yield*/, effects_1.put(AlertAction_1.default.setSaveSearchSetEnabled(notificationId, newChannel.length ? true : false))];
                                                case 2:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    })];
                            case 3:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var watchSaveSearchMobileEnabled = function () {
    var _loop_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_2 = function () {
                    var payload, notificationId, channels, mobileIndex, newChannel;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(AlertAction_1.default.ON_CHANGE_SAVE_SEARCH_MOBILE_ENABLED)];
                            case 1:
                                payload = (_a.sent()).payload;
                                notificationId = payload;
                                return [4 /*yield*/, effects_1.select(getSaveSearchNotificationChannel, notificationId)];
                            case 2:
                                channels = _a.sent();
                                mobileIndex = channels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.AppPush);
                                newChannel = mobileIndex > -1
                                    ? __spreadArrays(channels.slice(0, mobileIndex), channels.slice(mobileIndex + 1)) : __spreadArrays(channels, [NotificationChannelTypes_1.NotificationChannelTypes.AppPush]).sort();
                                return [4 /*yield*/, effects_1.fork(function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, effects_1.put(AlertAction_1.default.setSaveSearchSetChannel(notificationId, newChannel))];
                                                case 1:
                                                    _a.sent();
                                                    return [4 /*yield*/, effects_1.put(AlertAction_1.default.setSaveSearchSetEnabled(notificationId, newChannel.length ? true : false))];
                                                case 2:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    })];
                            case 3:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_2()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var watchFollowingEmailEnabled = function () {
    var _loop_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_3 = function () {
                    var payload, notificationId, channels, emailIndex, newChannel;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(AlertAction_1.default.ON_CHANGE_FOLLOWING_EMAIL_ENABLED)];
                            case 1:
                                payload = (_a.sent()).payload;
                                notificationId = payload;
                                return [4 /*yield*/, effects_1.select(getFollowingNotificationChannel, notificationId)];
                            case 2:
                                channels = _a.sent();
                                emailIndex = channels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.Email);
                                newChannel = emailIndex > -1
                                    ? __spreadArrays(channels.slice(0, emailIndex), channels.slice(emailIndex + 1)) : __spreadArrays(channels, [NotificationChannelTypes_1.NotificationChannelTypes.Email]).sort();
                                return [4 /*yield*/, effects_1.fork(function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, effects_1.put(AlertAction_1.default.setFollowingPlacesChannel(notificationId, newChannel))];
                                                case 1:
                                                    _a.sent();
                                                    return [4 /*yield*/, effects_1.put(AlertAction_1.default.setFollowingPlacesEnabled(notificationId, newChannel.length ? true : false))];
                                                case 2:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    })];
                            case 3:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_3()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var watchFollowingMobileEnabled = function () {
    var _loop_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_4 = function () {
                    var payload, notificationId, channels, mobileIndex, newChannel;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(AlertAction_1.default.ON_CHANGE_FOLLOWING_MOBILE_ENABLED)];
                            case 1:
                                payload = (_a.sent()).payload;
                                notificationId = payload;
                                return [4 /*yield*/, effects_1.select(getFollowingNotificationChannel, notificationId)];
                            case 2:
                                channels = _a.sent();
                                mobileIndex = channels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.AppPush);
                                newChannel = mobileIndex > -1
                                    ? __spreadArrays(channels.slice(0, mobileIndex), channels.slice(mobileIndex + 1)) : __spreadArrays(channels, [NotificationChannelTypes_1.NotificationChannelTypes.AppPush]).sort();
                                return [4 /*yield*/, effects_1.fork(function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, effects_1.put(AlertAction_1.default.setFollowingPlacesChannel(notificationId, newChannel))];
                                                case 1:
                                                    _a.sent();
                                                    return [4 /*yield*/, effects_1.put(AlertAction_1.default.setFollowingPlacesEnabled(notificationId, newChannel.length ? true : false))];
                                                case 2:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    })];
                            case 3:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_4()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var watchToggleAllSaveSearchEmail = function () {
    var isEnabled, notificationIds, i, uncheckedNotificationIds, i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 14];
                return [4 /*yield*/, effects_1.take(AlertAction_1.default.ON_CLICK_ALL_SAVED_SEARCHES_EMAIL)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getIsAllSaveSearchEmailEnabled)];
            case 2:
                isEnabled = _a.sent();
                if (!isEnabled) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.select(getSaveSearchEmailNotificationIds)];
            case 3:
                notificationIds = _a.sent();
                i = 0;
                _a.label = 4;
            case 4:
                if (!(i < notificationIds.length)) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.onChangeSaveSearchEmailEnabled(notificationIds[i]))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6:
                i = i + 1;
                return [3 /*break*/, 4];
            case 7: return [3 /*break*/, 13];
            case 8: return [4 /*yield*/, effects_1.select(getSaveSearchEmailNotificationIdsUnchecked)];
            case 9:
                uncheckedNotificationIds = _a.sent();
                i = 0;
                _a.label = 10;
            case 10:
                if (!(i < uncheckedNotificationIds.length)) return [3 /*break*/, 13];
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.onChangeSaveSearchEmailEnabled(uncheckedNotificationIds[i]))];
            case 11:
                _a.sent();
                _a.label = 12;
            case 12:
                i = i + 1;
                return [3 /*break*/, 10];
            case 13: return [3 /*break*/, 0];
            case 14: return [2 /*return*/];
        }
    });
};
var watchToggleAllSaveSearchMobile = function () {
    var isEnabled, notificationIds, i, uncheckedNotificationIds, i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 14];
                return [4 /*yield*/, effects_1.take(AlertAction_1.default.ON_CLICK_ALL_SAVED_SEARCHES_MOBILE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getIsAllSaveSearchMobileEnabled)];
            case 2:
                isEnabled = _a.sent();
                if (!isEnabled) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.select(getSaveSearchMobileNotificationIds)];
            case 3:
                notificationIds = _a.sent();
                i = 0;
                _a.label = 4;
            case 4:
                if (!(i < notificationIds.length)) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.onChangeSaveSearchMobileEnabled(notificationIds[i]))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6:
                i = i + 1;
                return [3 /*break*/, 4];
            case 7: return [3 /*break*/, 13];
            case 8: return [4 /*yield*/, effects_1.select(getSaveSearchMobileNotificationIdsUnchecked)];
            case 9:
                uncheckedNotificationIds = _a.sent();
                i = 0;
                _a.label = 10;
            case 10:
                if (!(i < uncheckedNotificationIds.length)) return [3 /*break*/, 13];
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.onChangeSaveSearchMobileEnabled(uncheckedNotificationIds[i]))];
            case 11:
                _a.sent();
                _a.label = 12;
            case 12:
                i = i + 1;
                return [3 /*break*/, 10];
            case 13: return [3 /*break*/, 0];
            case 14: return [2 /*return*/];
        }
    });
};
var watchToggleAllFollowingEmail = function () {
    var isEnabled, notificationIds, i, uncheckedNotificationIds, i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 14];
                return [4 /*yield*/, effects_1.take(AlertAction_1.default.ON_CLICK_ALL_FOLLOWING_PLACES_EMAIL)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getIsAllFollowingEmailEnabled)];
            case 2:
                isEnabled = _a.sent();
                if (!isEnabled) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.select(getFollowingPlacesEmailNotificationIds)];
            case 3:
                notificationIds = _a.sent();
                i = 0;
                _a.label = 4;
            case 4:
                if (!(i < notificationIds.length)) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.onChangeFollowingEmailEnabled(notificationIds[i]))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6:
                i = i + 1;
                return [3 /*break*/, 4];
            case 7: return [3 /*break*/, 13];
            case 8: return [4 /*yield*/, effects_1.select(getFollowingPlacesEmailNotificationIdsUnchecked)];
            case 9:
                uncheckedNotificationIds = _a.sent();
                i = 0;
                _a.label = 10;
            case 10:
                if (!(i < uncheckedNotificationIds.length)) return [3 /*break*/, 13];
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.onChangeFollowingEmailEnabled(uncheckedNotificationIds[i]))];
            case 11:
                _a.sent();
                _a.label = 12;
            case 12:
                i = i + 1;
                return [3 /*break*/, 10];
            case 13: return [3 /*break*/, 0];
            case 14: return [2 /*return*/];
        }
    });
};
var watchToggleAllFollowingMobile = function () {
    var isEnabled, notificationIds, i, uncheckedNotificationIds, i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 14];
                return [4 /*yield*/, effects_1.take(AlertAction_1.default.ON_CLICK_ALL_FOLLOWING_PLACES_MOBILE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getIsAllFollowingMobileEnabled)];
            case 2:
                isEnabled = _a.sent();
                if (!isEnabled) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.select(getFollowingPlacesMobileNotificationIds)];
            case 3:
                notificationIds = _a.sent();
                i = 0;
                _a.label = 4;
            case 4:
                if (!(i < notificationIds.length)) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.onChangeFollowingMobileEnabled(notificationIds[i]))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6:
                i = i + 1;
                return [3 /*break*/, 4];
            case 7: return [3 /*break*/, 13];
            case 8: return [4 /*yield*/, effects_1.select(getFollowingPlacesMobileNotificationIdsUnchecked)];
            case 9:
                uncheckedNotificationIds = _a.sent();
                i = 0;
                _a.label = 10;
            case 10:
                if (!(i < uncheckedNotificationIds.length)) return [3 /*break*/, 13];
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.onChangeFollowingMobileEnabled(uncheckedNotificationIds[i]))];
            case 11:
                _a.sent();
                _a.label = 12;
            case 12:
                i = i + 1;
                return [3 /*break*/, 10];
            case 13: return [3 /*break*/, 0];
            case 14: return [2 /*return*/];
        }
    });
};
var watchUnsubscribeClicked = function () {
    var notificationIds, i, notificationIds, i, notificationIds, i, notificationIds, i, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 30];
                return [4 /*yield*/, effects_1.take(AlertAction_1.default.ON_UNSUBSCRIBE_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getSaveSearchEmailNotificationIds)];
            case 2:
                notificationIds = _a.sent();
                i = 0;
                _a.label = 3;
            case 3:
                if (!(i < notificationIds.length)) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.onChangeSaveSearchEmailEnabled(notificationIds[i]))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5:
                i = i + 1;
                return [3 /*break*/, 3];
            case 6: return [4 /*yield*/, effects_1.select(getSaveSearchMobileNotificationIds)];
            case 7:
                notificationIds = _a.sent();
                i = 0;
                _a.label = 8;
            case 8:
                if (!(i < notificationIds.length)) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.onChangeSaveSearchMobileEnabled(notificationIds[i]))];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10:
                i = i + 1;
                return [3 /*break*/, 8];
            case 11: return [4 /*yield*/, effects_1.select(getFollowingPlacesEmailNotificationIds)];
            case 12:
                notificationIds = _a.sent();
                i = 0;
                _a.label = 13;
            case 13:
                if (!(i < notificationIds.length)) return [3 /*break*/, 16];
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.onChangeFollowingEmailEnabled(notificationIds[i]))];
            case 14:
                _a.sent();
                _a.label = 15;
            case 15:
                i = i + 1;
                return [3 /*break*/, 13];
            case 16: return [4 /*yield*/, effects_1.select(getFollowingPlacesMobileNotificationIds)];
            case 17:
                notificationIds = _a.sent();
                i = 0;
                _a.label = 18;
            case 18:
                if (!(i < notificationIds.length)) return [3 /*break*/, 21];
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.onChangeFollowingMobileEnabled(notificationIds[i]))];
            case 19:
                _a.sent();
                _a.label = 20;
            case 20:
                i = i + 1;
                return [3 /*break*/, 18];
            case 21: return [4 /*yield*/, effects_1.put(AlertAction_1.default.setMarketUpdate(false))];
            case 22:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.setIsLoading(true))];
            case 23:
                _a.sent();
                return [4 /*yield*/, effects_1.call(SaveSearchApiSaga_1.unsubscribeApi)];
            case 24:
                response = _a.sent();
                return [4 /*yield*/, effects_1.put(AlertAction_1.default.setIsLoading(false))];
            case 25:
                _a.sent();
                if (!(response && response.data.result.status === 2)) return [3 /*break*/, 27];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('alertUpdateSuccess'))];
            case 26:
                _a.sent();
                return [3 /*break*/, 29];
            case 27: return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('alertUpdateFailed'))];
            case 28:
                _a.sent();
                _a.label = 29;
            case 29: return [3 /*break*/, 0];
            case 30: return [2 /*return*/];
        }
    });
};
var alertSagas = {
    watchOnChangeSaveSearchAlert: watchOnChangeSaveSearchAlert,
    watchOnChangeMarketUpdate: watchOnChangeMarketUpdate,
    watchAlertSave: watchAlertSave,
    watchSaveSearchEmailEnabled: watchSaveSearchEmailEnabled,
    watchSaveSearchMobileEnabled: watchSaveSearchMobileEnabled,
    watchFollowingEmailEnabled: watchFollowingEmailEnabled,
    watchFollowingMobileEnabled: watchFollowingMobileEnabled,
    watchToggleAllSaveSearchEmail: watchToggleAllSaveSearchEmail,
    watchToggleAllSaveSearchMobile: watchToggleAllSaveSearchMobile,
    watchToggleAllFollowingEmail: watchToggleAllFollowingEmail,
    watchToggleAllFollowingMobile: watchToggleAllFollowingMobile,
    watchUnsubscribeClicked: watchUnsubscribeClicked,
};
exports.alertSagas = alertSagas;
